import api from '@/services/backendApi';

const userUrl = '/user';

export default {
	getAllUsers() {
		return api.get(`${userUrl}/getAll`);
	},
	getUserById(id) {
		return api.get(`${userUrl}/getUser/${id}`);
	},
	updateUser(updatedUser) {
		return api.put(`${userUrl}/updateUser/${updatedUser._id}`, updatedUser);
	},
	delete(user) {
		return api.delete(`${userUrl}/delete/${user._id}`, user);
	},
};
